__turbopack_context__.v({
  "alertYellow": "_34usWG_alertYellow",
  "black": "_34usWG_black",
  "black90": "_34usWG_black90",
  "comparisonTable": "_34usWG_comparisonTable",
  "content": "_34usWG_content",
  "controls": "_34usWG_controls",
  "cyan": "_34usWG_cyan",
  "darkMode": "_34usWG_darkMode",
  "darkSecondColumn": "_34usWG_darkSecondColumn",
  "darkStone": "_34usWG_darkStone",
  "fuschiaPunch": "_34usWG_fuschiaPunch",
  "hasControls": "_34usWG_hasControls",
  "hidden": "_34usWG_hidden",
  "isBlog": "_34usWG_isBlog",
  "item": "_34usWG_item",
  "last": "_34usWG_last",
  "limeSorbet": "_34usWG_limeSorbet",
  "logo": "_34usWG_logo",
  "noBottomMargin": "_34usWG_noBottomMargin",
  "olive100": "_34usWG_olive100",
  "olive20": "_34usWG_olive20",
  "paddingBottom0": "_34usWG_paddingBottom0",
  "paddingBottom112": "_34usWG_paddingBottom112",
  "paddingBottom128": "_34usWG_paddingBottom128",
  "paddingBottom16": "_34usWG_paddingBottom16",
  "paddingBottom32": "_34usWG_paddingBottom32",
  "paddingBottom48": "_34usWG_paddingBottom48",
  "paddingBottom64": "_34usWG_paddingBottom64",
  "paddingBottom80": "_34usWG_paddingBottom80",
  "paddingBottom96": "_34usWG_paddingBottom96",
  "paddingTop0": "_34usWG_paddingTop0",
  "paddingTop112": "_34usWG_paddingTop112",
  "paddingTop128": "_34usWG_paddingTop128",
  "paddingTop16": "_34usWG_paddingTop16",
  "paddingTop32": "_34usWG_paddingTop32",
  "paddingTop48": "_34usWG_paddingTop48",
  "paddingTop64": "_34usWG_paddingTop64",
  "paddingTop80": "_34usWG_paddingTop80",
  "paddingTop96": "_34usWG_paddingTop96",
  "reducedWidth": "_34usWG_reducedWidth",
  "show": "_34usWG_show",
  "softBlack": "_34usWG_softBlack",
  "spacer": "_34usWG_spacer",
  "tableContainer": "_34usWG_tableContainer",
  "teal100": "_34usWG_teal100",
  "teal20": "_34usWG_teal20",
  "tintFirstColumn": "_34usWG_tintFirstColumn",
  "warmStone": "_34usWG_warmStone",
  "white": "_34usWG_white",
});
